import { render, staticRenderFns } from "./BrandmL.vue?vue&type=template&id=e54091d4&"
import script from "./BrandmL.vue?vue&type=script&lang=js&"
export * from "./BrandmL.vue?vue&type=script&lang=js&"
import style0 from "./BrandmL.vue?vue&type=style&index=0&id=e54091d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports